import {Component, Input, OnInit} from '@angular/core';
import {PlayersManualSelectService} from "../../services/players-manual-select.service";
import {BracketItemService} from "../../services/bracket-item.service";
import {cloneDeep} from "lodash";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-manual-set-players',
  templateUrl: './manual-set-players.component.html',
  styleUrls: ['./manual-set-players.component.scss']
})
export class ManualSetPlayersComponent implements OnInit {

  @Input() playerOrder: number;
  @Input() duelNumber: number;

  private _listOfPlayersForManualAdd: playerForManualAddInfo[] = [];
  constructor(
    private manualSelectService: PlayersManualSelectService,
    private bracketsService: BracketItemService,
    private activeModal: NgbActiveModal,
  ) { }

  getTournamentIdFromUrl(): number {
    return +(window.location.href.match(/\/(\d+)(?=\/)/gi)[0].slice(1,));
  }
  ngOnInit(): void {
    this.manualSelectService
      .getPlayersForManualSet(this.getTournamentIdFromUrl())
      .subscribe((listOfPlayers: playerForManualAddInfo[]) => {
        this.listOfPlayersForManualAdd = listOfPlayers;
    });
  }

  get listOfPlayersForManualAdd() {
    return cloneDeep(this._listOfPlayersForManualAdd);
  }

  set listOfPlayersForManualAdd(listOfPlayers) {
    this._listOfPlayersForManualAdd = cloneDeep(listOfPlayers);
  }

  addPlayerManually(player_id: number) {
    const ds_num = this.duelNumber;
    const ds_player_num = this.playerOrder;
    this.manualSelectService.setCertainPlayer(
      this.getTournamentIdFromUrl(),
      {
        player_id,
        ds_num,
        ds_player_num,
      }
    ).subscribe(() => {
      this.bracketsService.updateAll();
      this.activeModal.close();
    });
  }

  getDisplayedColumns() {
    return [
      'fullName',
      'addButton',
    ]
  }

}

interface playerForManualAddInfo {
  id: number,
  full_name: string,
}
